import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import PatientService from "../../Services/PatientService";
import medDouble from "../../assets/PrescriptionUpload/medicineDouble.png";
import truck from "../../assets/PrescriptionUpload/truck.png";
import presImage from "../../assets/PrescriptionUpload/prescription1.png";
import presConfirm from "../../assets/PrescriptionUpload/presConfirm.png";
import { message } from "antd";

const PrescriptionUpload = () => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [previewURL, setPreviewURL] = useState("");
  const [error, setError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { patientData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const MAX_SIZE = 10 * 1024 * 1024;

  const handleUpload = () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    setError("");
    fileInputRef.current?.click();
  };

  const handleSendOrder = async () => {
    if (!file) {
      setError("Please upload a prescription before sending the order.");
      return;
    }

    setError("");
    setIsUploading(true);

    try {
      const toBase64 = (f) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = () => reject(new Error("File reading failed"));
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(f);
        });

      const dataUrl = await toBase64(file); // e.g. data:image/jpeg;base64,/9j/4AAQSk...
      const base64 = dataUrl.split(",")[1] || "";

      // determine file type/extension
      let ext = "";
      if (file.type) {
        const parts = file.type.split("/");
        ext = parts[1] || "";
      }
      if (!ext && file.name) {
        const nameParts = file.name.split(".");
        ext = nameParts.length > 1 ? nameParts.pop() : "";
      }

      const payload = {
        firstName: patientData?.firstName || "",
        lastName: patientData?.lastName || "",
        createdBy: patientData?.createdBy || "DOXADMIN",
        modifiedBy: patientData?.modifiedBy || "DOXADMIN",
        patientId: patientData?.patientId,
        gender: patientData?.gender || "",
        mobile: patientData?.mobile || "",
        status: 1,
        patientType: "E",
        prescriptionImage: base64,
        prescriptionType: ext,
        createdDate: new Date().toISOString().slice(0, 19).replace("T", " "),
        modifiedDate: new Date().toISOString().slice(0, 19).replace("T", " "),
      };


      let res = await PatientService.SendPrescriptionFile(payload);
      setFile(null);
      setPreviewURL("");
      message.success("Prescription sent successfully! We will contact you soon.");
    } catch (err) {
      console.error(err);
      setError("Failed to prepare the order. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    if (f.size > MAX_SIZE) {
      setError("File exceeds 10 MB limit. Please choose a smaller file.");
      return;
    }

    setIsUploading(true);
    setTimeout(() => {
      const url = URL.createObjectURL(f);
      setFile(f);
      setPreviewURL(url);
      setIsUploading(false);
    }, 700);
  };

  const closeModal = () => {
    setModalOpen(false);
    if (previewURL) {
      URL.revokeObjectURL(previewURL);
    }
    setPreviewURL("");
  };

  return (
    <div className="w-full h-fit rounded-2xl bg-gradient-to-b from-[#189FAA] via-[#FFFFFF] to-[#4FB3B3] p-5 text-center shadow-lg sticky top-24">
      <h2 className="text-teal-800 font-semibold text-lg leading-snug">
        Upload Prescription and <br /> Get Medicine...
      </h2>

      <div className="flex justify-center mt-2 mb-4 text-5xl">
        <img src={medDouble} alt="" className="h-16 object-contain" />
      </div>

      <div className="flex flex-col items-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-teal-400 bg-white text-2xl text-teal-600 shadow">
          <img src={presImage} alt="" />
        </div>
        <p className="mt-3 text-sm text-gray-700 font-medium">
          Upload Your <br /> Prescription
        </p>
      </div>

      <div className="my-2 text-teal-500 text-xl">↓</div>

      <div className="flex flex-col items-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-teal-400 bg-white text-2xl text-teal-600 shadow">
          <img src={presConfirm} alt="" />
        </div>
        <p className="mt-3 text-sm text-gray-700 font-medium">
          We Confirm <br /> & Process It
        </p>
      </div>

      <div className="my-2 text-teal-500 text-xl">↓</div>

      <div className="flex flex-col items-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-teal-400 bg-white text-2xl text-teal-600 shadow">
          <img src={truck} alt="" />
        </div>
        <p className="mt-3 text-sm text-gray-700 font-medium">
          Receive Medicine <br /> at Your Door
        </p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="application/pdf,image/*"
        className="hidden"
        onChange={handleFileChange}
      />

      {error && <p className="mt-3 text-sm text-red-600">{error}</p>}

      <button
        onClick={handleUpload}
        className="mt-4 w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 rounded-lg transition duration-300 shadow-md"
        disabled={isUploading}
      >
        {isUploading ? "Uploading..." : "Upload Prescription"}
      </button>
      {file && !isUploading && (<div className="flex gap-1 w-full justify-center">



        <button
          onClick={() => setModalOpen(true)}
          className="mt-3 gap-2 px-3 w-full text-center py-1 text-sm text-teal-700 bg-white border border-teal-200 rounded shadow-sm hover:bg-teal-50"
          aria-label="View uploaded prescription"
        >
          View
        </button>

        <button
          onClick={() => {
            setFile(null);
            setPreviewURL("");
          }}
          className="mt-3 gap-2 px-3 w-full text-center py-1 text-sm text-teal-700 bg-white border border-teal-200 rounded shadow-sm hover:bg-teal-50"
          aria-label="Delete uploaded prescription"
        >
          Delete
        </button>

      </div>)}
      {file &&
        <button
          onClick={handleSendOrder}
          className="mt-2 w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 rounded-lg transition duration-300"
        //   disabled={isUploading}
        >
          Send Order
        </button>
      }


      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[90vh] overflow-auto p-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold">Preview</h3>
              <button
                onClick={closeModal}
                className="text-gray-600 hover:text-gray-800"
                aria-label="Close preview"
              >
                ✕
              </button>
            </div>

            <div className="w-full h-[70vh]">
              {file && file.type.startsWith("image/") ? (
                <img
                  src={previewURL}
                  alt="preview"
                  className="w-full h-full object-contain"
                />
              ) : (
                <iframe
                  title="preview"
                  src={previewURL}
                  className="w-full h-full border"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrescriptionUpload;
